import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import {
  formatMoney,
  mapInvoicePaymentStatus,
  mapInvoicePaymentStatusColor,
  mapBcSyncStatus,
  mapBcSyncStatusColor,
} from '../../utils';

import styles from './invoices.module.scss';
import { INVOICE_STATUS_PAID, BC_SYNC_STATUS_FAILED } from './constants';

const InvoicesInfo = ({
  invoice: { status, total_debt, bc_sync_status, bc_error },
}) => {
  const displayDebtSum = useMemo(() => {
    return status !== INVOICE_STATUS_PAID;
  }, [status]);

  const info = [
    {
      title: 'Būsena',
      data: (
        <span style={{ color: mapInvoicePaymentStatusColor(status) }}>
          {mapInvoicePaymentStatus(status)}
        </span>
      ),
    },
    {
      title: 'BC sinchronizacija',
      data: (
        <span style={{ color: mapBcSyncStatusColor(bc_sync_status) }}>
          {mapBcSyncStatus(bc_sync_status)}
        </span>
      ),
      error:
        bc_sync_status === BC_SYNC_STATUS_FAILED && bc_error ? bc_error : null,
    },
    ...(displayDebtSum
      ? [
          {
            title: 'Skola su PVM',
            data: <span>{formatMoney(total_debt)}</span>,
          },
        ]
      : []),
  ];

  const renderInfo = () =>
    info.map(({ title, data, error }) => (
      <div className={styles.infoRow} key={title}>
        <span>{title}</span>
        <span>{data}</span>
        {error && <span className={styles.bcSyncError}>{error}</span>}
      </div>
    ));

  return (
    <div className={styles.document} style={{ marginTop: 49 }}>
      <div className={styles.invoiceInfo}>{renderInfo()}</div>
    </div>
  );
};

InvoicesInfo.defaultProps = {
  status: '-',
  total_debt: 0,
};

InvoicesInfo.propTypes = {
  invoice: PropTypes.shape({
    status: PropTypes.number,
    total_debt: PropTypes.number,
    bc_sync_status: PropTypes.string,
    bc_error: PropTypes.string,
  }).isRequired,
};

export default InvoicesInfo;
